// extracted by mini-css-extract-plugin
export var container = "_bx-0";
export var outlet = "_bx-1";
export var outletEnter = "_bx-2";
export var outletEnterActive = "_bx-3";
export var outletExit = "_bx-4";
export var outletExitActive = "_bx-5";